/* eslint-disable no-unused-vars */
/* eslint-disable react-hooks/exhaustive-deps */
import React, { useCallback, useEffect, useState } from "react";
import APP_CONST from "../../../shared/constants";
import Loader from "../../shared/Loader/Loader";
import DeleteDocumentPopUp from "../../shared/DeleteDocumentPopUp/DeleteDocumentPopUp";
import ProgressBar from "../../shared/widgets/ProgressBar";

import { useTranslation } from "react-i18next";
import { useDropzone } from "react-dropzone";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { storageFactory } from "../../../../../utils/storageFactory";
import { StorageHelper } from "../../../../../utils/storageHelper";
import { BlobServiceClient } from "@azure/storage-blob";
import { ViedocCheckboxElement } from "../../../../secure/elements/ViedocReactElements";

import * as documentActions from "../../../../store/actions/documentActions";
import * as loaderActions from "../../../../store/actions/loaderActions";
import * as UtilsHelper from "../../../../../utils/utilsHelper";
import * as DocumentService from "../../../../secure/services/documentService";
import * as TemplateService from "../../../../secure/services/templateService";
import * as templateActions from "../../../../store/actions/templateActions";
import * as fileUploadActions from "../../../../store/actions/fileUploadActions";
import _ from "underscore";
import DocumentViewModal from "../ZonesSections/DocumentViewModal";

const TrailMasterDropZone = () => {
  const { t } = useTranslation();
  const dispatch = useDispatch();

  const {
    dropZoneDoc,
    fullDateTimePattern,
    dateLocale,
    loading,
    settings,
    invalidDoc,
    isEtmfLocked,
    isLoading,
    sharedfilecount,
    privatefilecount,
  } = useSelector((store) => store.template);
  const { userList, viewPerPageCount } = useSelector((store) => store.zone);
  const navigate = useNavigate();

  const localStore = storageFactory(() => sessionStorage);
  const [category, setCategory] = useState(() => returnCategory());
  const [DragContainer, setDragContainer] = useState(false);
  const [showDocDeletePopup, setShowDocDeletePopup] = useState(false);
  const [docDeleteData, setDocDeleteData] = useState({});
  const [setViewDocument, setViewDocumentObj] = useState(false);
  const [docIndex, setDocIndex] = useState();
  const [invalidFileUploaded, setInvalidFileUploaded] = useState(false);
  const [categoryChecked, setCategoryChecked] = useState(true);
  const [tmpfileGuid, setTmpFileGuid] = useState(null);
  const [tmpSingleFileDetail, setTmpSingleFileDetail] = useState(null);
  const [isDocNewVersionCreated, setIsDocNewVersionCreated] = useState(false);
  let dropZoneItems = [...dropZoneDoc];

  function returnCategory() {
    if (settings.isshareddropzoneenabled || sharedfilecount >= 1) {
      return APP_CONST.SHARED_TEXT;
    } else if (settings.isprivatedropzoneenabled || privatefilecount >= 1) {
      return APP_CONST.PRIVATE_TEXT;
    } else {
      return APP_CONST.SHARED_TEXT;
    }
  }

  useEffect(() => {
    dispatch(templateActions.getDropZoneSettings());
    dispatch(documentActions.getAdminSharingSettings());
    category === APP_CONST.SHARED_TEXT
      ? dispatch(templateActions.fetchDropZoneDocuments(category))
      : dispatch(templateActions.fetchDropZoneDocuments(category));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [category]);

  useEffect(() => {
    resetDropZone();
  }, [privatefilecount, sharedfilecount]);

  const resetDropZone = () => {
    if (
      !privatefilecount &&
      !sharedfilecount &&
      !settings.isprivatedropzoneenabled &&
      !settings.isshareddropzoneenabled
    ) {
      navigate("/zone-section");
    } else if (!privatefilecount && !settings.isprivatedropzoneenabled) {
      setCategory(APP_CONST.SHARED_TEXT);
    } else if (!sharedfilecount && !settings.isshareddropzoneenabled) {
      setCategory(APP_CONST.PRIVATE_TEXT);
    }
  };

  const onDownloadIconClick = (data, isDialog) => {
    let downTemplate = "";
    const origfilename = data.origfilename
      ? data.origfilename.split(`.${data.type}`)[0]
      : data.filename.split(`.${data.fileextension}`)[0];
    const downloadFileName =
      downTemplate && downTemplate !== ""
        ? downTemplate
        : data.title === "customName"
        ? data.customTitle
        : APP_CONST.TITLE_ARRAY.includes(data.title)
        ? data.documenttypevalue || data.artifact
        : origfilename;
    const fileProps = {
      ...data,
      downloadFileName,
    };
    data.tmfdropzoneid || data.category
      ? dispatch(
          fileUploadActions.fileDownloadUrl(
            UtilsHelper.prepareDownloadRequestPayload(fileProps),
            isDialog,
            data.category
          )
        )
      : dispatch(
          fileUploadActions.fileDownloadUrl(
            UtilsHelper.prepareDownloadRequestPayload(fileProps),
            isDialog,
            "",
            fileProps
          )
        );
  };

  const uploadWithSASGeneration = async (file, guid) => {
    try {
      const sasTokenResult = await TemplateService.doFetchSAStoken();
      const { data } = sasTokenResult;
      const studyConfig = StorageHelper.getStudyConfig();
      if (!data.isError) {
        const { sastoken } = data.result;
        const decodedToken = atob(sastoken);
        const containerName = decodedToken.substring(
          decodedToken.lastIndexOf("/") + 1,
          decodedToken.lastIndexOf("?")
        );

        const splitDecodeURL = decodedToken.split(`/${containerName}?`);
        const sasString = `${splitDecodeURL[0]}/?${splitDecodeURL[1]}`;
        const containerURL = new BlobServiceClient(sasString);
        const containerClient = containerURL.getContainerClient(containerName);
        const updataGuid =
          category === APP_CONST.SHARED_TEXT
            ? `SharedDZ_${guid}_${studyConfig.studyid}`
            : `PrivateDZ_${guid}_${studyConfig.studyid}`;
        // const blobResp = await containerClient.getBlobClient(updataGuid).exists();
        // if (blobResp === false) {}
        // else { return "File Already exists";}
        const blockBlobClient = containerClient.getBlockBlobClient(updataGuid);
        const config = {
          metadata: {
            // filename: file.name,
          },
        };
        return blockBlobClient.uploadBrowserData(file, config);
      }

      // }
    } catch (error) {
      return "error";
    }
  };

  const uploadDocData = async (
    uploadFile,
    guid,
    index,
    createdDate,
    uploadDropZoneDocIndex
  ) => {
    const fileType = UtilsHelper.getFileExtension(uploadFile.name);
    // dispatch(zoneActions.enableAggridIcon(false));
    let documentItem = {
      filename: uploadFile.name,
      category: category,
      id: uploadFile.lastModified,
      fileextension: fileType,
      size: uploadFile.size,
    };
    if (
      uploadFile.size !== 0 &&
      !APP_CONST.BLACK_LISTED_FILE_FORMATS.includes(fileType)
    ) {
      const azureData = uploadWithSASGeneration(uploadFile, guid);

      const documentData = {
        ...documentItem,
        isUploading: true,
        uploadingProgress: UtilsHelper.randomNumber([14, 16, 29]),
        category: category,
        guid: guid,
        azureData,
        createdon: "",
        createdby: "",
      };

      const requestPayload = {
        type: "DropZoneFile",
        fileName: uploadFile.name,
        category: category,
        status: "Upload In-Progress",
        statusMessage: "Upload In-Progress",
        fileGuid: guid,
        createdon: createdDate,
      };

      let docIndex = uploadDropZoneDocIndex.filter(
        (data) => data.uploadDocIndex === index
      )[0].indexToBeReplaced;

      dispatch(
        templateActions.doDropZoneFileScreening({
          requestPayload,
          guid,
          documentData,
          index,
          docIndex,
          viewPerPageCount,
        })
      );
    } else {
      const documentData = { ...documentItem, isUploading: false };
      setInvalidFileUploaded(true);
      if (
        APP_CONST.BLACK_LISTED_FILE_FORMATS.includes(documentData.fileextension)
      ) {
        documentData.comments = `${t("TMF.TOAST_INVALIDBLOCKLISTFILE")}`;
        dispatch(templateActions.setInvalidError(documentData));
      } else if (uploadFile.size === 0) {
        documentData.comments = `${t("TMF.TOAST_FILEEMPTY")}`;
        dispatch(templateActions.setInvalidError(documentData));
      }
    }
  };

  const onUploadFn = async (files) => {
    if (files && files.length > 0) {
      let fileData = Array.from(files);
      fileData = fileData.sort(function (a, b) {
        if (a.name < b.name) {
          return -1;
        }
        if (a.name > b.name) {
          return 1;
        }
        return 0;
      });
      let fileDoc = [];
      let uploadDropZoneDocIndex = {
        Shared: [],
        Private: [],
      };
      for (let i = 0; i < fileData.length; i++) {
        if (
          fileData[i].size !== 0 &&
          !APP_CONST.BLACK_LISTED_FILE_FORMATS.includes(
            UtilsHelper.getFileExtension(fileData[i].name)
          )
        ) {
          let fileObj = {
            fileextension: UtilsHelper.getFileExtension(fileData[i].name),
            filename: fileData[i].name,
            createdon: "",
            createdby: "",
            isUploading: true,
            size: fileData[i].size,
            category: category,
            uploadingProgress: 7,
          };
          if (fileDoc.length === 0) {
            uploadDropZoneDocIndex[category][0] = {
              indexToBeReplaced: 0,
              uploadDocIndex: i,
            };
          } else {
            let getIndex = fileDoc.length;
            uploadDropZoneDocIndex[category][getIndex] = {
              indexToBeReplaced: getIndex,
              uploadDocIndex: i,
            };
          }
          fileDoc.push(fileObj);
        }
      }
      localStore.setItem(
        category,
        JSON.stringify([...fileDoc, ...dropZoneItems])
      );
      dispatch(
        templateActions.setDropZoneItems([...fileDoc, ...dropZoneItems])
      );
      let guidList = [];
      DocumentService.doGetDropZoneDocumentGuid(fileData.length)
        .then(async (response) => {
          const { isError, result } = response.data;
          if (!isError) {
            guidList = result.documentguids;
            for (let i = 0; i < fileData.length; i++) {
              let dropZoneIndex = uploadDropZoneDocIndex[category];
              await uploadDocData(
                fileData[i],
                guidList[i],
                i,
                result.serverdatetime,
                dropZoneIndex
              );
              if (i === fileData.length - 1) {
                uploadDropZoneDocIndex[category] = [];
              }
            }
          } else {
            console.error("onUploadFn SOMETHING_WENT_WRONG", response);
          }
        })
        .catch(() => {
          dispatch(
            loaderActions.showError(
              t("TMF.TOAST_SOMETHINGWENTWRONG"),
              "error",
              "warning"
            )
          );
        });
    } else {
      dispatch(
        loaderActions.showError(t("TMF.TOAST_INVALIDFILE"), "error", "warning")
      );
    }
  };

  const handleDisplayCategory = (checkedValue) => {
    checkedValue
      ? setCategory(APP_CONST.PRIVATE_TEXT)
      : setCategory(APP_CONST.SHARED_TEXT);
    setInvalidFileUploaded(false);
    setCategoryChecked(!categoryChecked);
  };

  const onDrop = useCallback(
    (acceptedFiles) => {
      onUploadFn(acceptedFiles);
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [category, dropZoneDoc]
  );

  // eslint-disable-next-line no-unused-vars
  const { getRootProps, getInputProps, isDragActive } = useDropzone({ onDrop });

  const generateDateTime = (documentData) => {
    return documentData.lastmodifiedon
      ? fullDateTimePattern
        ? UtilsHelper.getFormattedDateTime(
            fullDateTimePattern,
            documentData.lastmodifiedon,
            dateLocale
          )
        : UtilsHelper.momentLocalConversion(documentData.lastmodifiedon, true)
      : fullDateTimePattern && documentData.createdon
      ? UtilsHelper.getFormattedDateTime(
          fullDateTimePattern,
          documentData.createdon,
          dateLocale
        )
      : UtilsHelper.momentLocalConversion(documentData.createdon, true);
  };

  const generateUserName = (documentData) => {
    return UtilsHelper.findUserName(
      userList,
      documentData.lastmodifiedby
        ? documentData.lastmodifiedby
        : documentData.createdby
    );
  };

  const getFileDetails = (documentData) => {
    return (
      <>
        {generateDateTime(documentData)} {t("TMF.TEXT_BY")}{" "}
        {generateUserName(documentData)}
      </>
    );
  };

  /*Represents a Table
   *Table used checkbox for selecting data
   */

  const documentViewHandler = (documentDetails, index) => {
    if (documentDetails.isUploading) return;
    setDocIndex(index);
    setViewDocumentObj(true);
    const { lastmodifiedon, fileguid, createdon, tmfdropzoneid } =
      documentDetails;
    const documentversionguid = APP_CONST.HARD_CODED.dummyId;
    const documentid = fileguid;
    const lastModifiedOn = lastmodifiedon ? lastmodifiedon : createdon;
    const payloadData = { documentid, lastModifiedOn, documentversionguid };

    dispatch(
      documentActions.getDocNote(
        documentversionguid,
        tmfdropzoneid ? tmfdropzoneid : APP_CONST.HARD_CODED.dummyId
      )
    );
    dispatch(documentActions.getDocumentHistory(payloadData));
  };
  const renderDocumentDetails = () => {
    return dropZoneDoc.map(
      (documentData, index) =>
        documentData.category === category && (
          <tr
            key={documentData.tmfdropzoneid}
            className="cursor-pointer"
            onClick={() => documentViewHandler(documentData, index)}
          >
            <td>
              {documentData.uploadingProgress ? (
                <viedoc-spinner size="small" class="spinner"></viedoc-spinner>
              ) : (
                // <viedoc-checkbox></viedoc-checkbox>
                <p></p>
              )}
            </td>
            <td>{documentData.filename}</td>
            <td className="light-grey">
              {documentData.fileextension.toUpperCase()}
            </td>
            <td className="light-grey">
              {generateUserName(documentData)
                ? getFileDetails(documentData)
                : null}
            </td>
            <td>
              {documentData.uploadingProgress &&
                documentData.category === category && (
                  <div className="document-upload-progress">
                    <ProgressBar
                      progress={documentData.uploadingProgress || 7}
                    />
                  </div>
                )}
            </td>
            <td>
              {documentData.uploadingProgress &&
              documentData.uploadingProgress === 99 ? (
                ""
              ) : documentData.uploadingProgress &&
                documentData.uploadingProgress !== 99 ? (
                <div
                  title={t("TMF.BUTTON_CANCELBTN")}
                  className="d-flex bin-box"
                  onClick={(e) => documentUploadCancelHandler(index, e)}
                >
                  <viedoc-icon name="delete" />
                </div>
              ) : (
                !isEtmfLocked && (
                  <div
                    title={t("TMF.TEXT_DELETE")}
                    className="d-flex bin-box"
                    onClick={(e) => documentDeleteHandler(documentData, e)}
                  >
                    {loading &&
                    documentData.tmfdropzoneid === docDeleteData.id ? (
                      <viedoc-spinner />
                    ) : (
                      <viedoc-icon name="delete_bin" />
                    )}
                  </div>
                )
              )}
            </td>
          </tr>
        )
    );
  };

  const documentUploadCancelHandler = (progressFileIndex, event) => {
    event.stopPropagation();
    const guid = dropZoneItems[progressFileIndex].guid;
    if (guid) {
      dispatch(
        templateActions.resetProgressFileData(
          dropZoneItems[progressFileIndex],
          "cancelled"
        )
      );
      dispatch(
        templateActions.getDropZoneFileScreeningStatusCancel(
          dropZoneItems[progressFileIndex]
        )
      );
    }
  };

  const documentDeleteHandler = (documentData, event) => {
    event.stopPropagation();
    setShowDocDeletePopup(true);
    setDocDeleteData({
      id: documentData.tmfdropzoneid,
      category: category,
      fileName: documentData.filename,
    });
  };

  const renderCategoryToggle = () => {
    return (
      <div className="d-flex align-center">
        <p
          className={
            "mr-8 " +
            (category === APP_CONST.SHARED_TEXT ? "dark-grey" : "light-grey") +
            (!settings.isshareddropzoneenabled && " line-through")
          }
        >
          {t("TMF.DROPZONELABEL_SHARED")}
        </p>
        <ViedocCheckboxElement
          onChange={(e) => handleDisplayCategory(e.srcElement.checked)}
          display-mode="toggle"
        ></ViedocCheckboxElement>
        <p
          className={
            "mr-8 " +
            (category === APP_CONST.PRIVATE_TEXT ? "dark-grey" : "light-grey") +
            (!settings.isprivatedropzoneenabled && " line-through")
          }
        >
          {t("TMF.DROPZONELABEL_PRIVATE")}
        </p>
      </div>
    );
  };

  const renderInvalidDocs = () => {
    return invalidDoc.map((documentData, index) => (
      <tr key={documentData.id} className="cursor-pointer invalid-files">
        <td>
          <div className="invalid-icon">
            <viedoc-icon name="close" />
          </div>
        </td>
        <td>{documentData.filename}</td>
        <td className="error-txt" title={t("TMF.TOAST_INVALIDBLOCKLISTFILE")}>
          {t("TMF.TOAST_INVALIDFILE")}
        </td>
        <td></td>
        <td></td>
        <td>
          <div
            title={t("TMF.BUTTON_CANCELBTN")}
            className="d-flex bin-box"
            onClick={(e) =>
              dispatch(templateActions.removeInvalidDoc(documentData, index))
            }
          >
            <viedoc-icon name="delete" />
          </div>
        </td>
      </tr>
    ));
  };

  const renderTable = () => {
    return (
      (!_.isEmpty(dropZoneDoc) || invalidFileUploaded) && (
        <aside>
          <table className="dropzone-item">
            <tr>
              <th className="w-2" style={{ background: "#fbfbfb" }}>
                {/* <viedoc-checkbox></viedoc-checkbox> */}
                <p></p>
              </th>
              <th className="w-35">{t("TMF.TEXT_NAME")}</th>
              <th className="w-3">{t("TMF.TEXT_TYPE")}</th>
              <th className="w-42">{t("TMF.TEXT_UPLOADED")}</th>
              <th className="w-10"></th>
              <th className="w-8">
                {/* <p className="hover-dots">...</p> */}
                <p></p>
              </th>
            </tr>
            {!_.isEmpty(invalidDoc) && renderInvalidDocs()}
            {renderDocumentDetails()}
          </table>
        </aside>
      )
    );
  };

  const getCategory = (category) => {
    switch (category) {
      case "Shared":
        return t("TMF.DROPZONELABEL_SHARED");
      case "Private":
        return t("TMF.DROPZONELABEL_PRIVATE");
      default:
        break;
    }
  };

  const renderCategory = () => {
    if (category === APP_CONST.SHARED_TEXT)
      return settings.isshareddropzoneenabled ? (
        "[" + getCategory(category) + "]"
      ) : (
        <span>
          [<span className="line-through">{getCategory(category)}</span>]
        </span>
      );
    else
      return settings.isprivatedropzoneenabled ? (
        "[" + getCategory(category) + "]"
      ) : (
        <span>
          [<span className="line-through">{getCategory(category)}</span>]
        </span>
      );
  };

  return (
    <div className="Tmf-dropzone-pageloader">
      {
        <section className="overview-dashboard">
          {showDocDeletePopup && (
            <DeleteDocumentPopUp
              deletePayload={docDeleteData}
              setShowDocDeletePopup={setShowDocDeletePopup}
              category={category}
              fromTo="Dropzone"
            />
          )}
          {setViewDocument && (
            <DocumentViewModal
              onDownloadIconClick={onDownloadIconClick}
              docDetails={dropZoneItems[docIndex]}
              category={category}
              setViewDocumentObj={setViewDocumentObj}
              setTmpFileGuid={setTmpFileGuid}
              setTmpSingleFileDetail={setTmpSingleFileDetail}
              setIsDocNewVersionCreated={setIsDocNewVersionCreated}
            />
          )}
          <header className="overview-content pl-30 pr-30">
            <h3>
              {t("TMF.DROPZONELABEL_DROPZONE")} {renderCategory()}
            </h3>
            <div>
              {(settings.isshareddropzoneenabled || sharedfilecount >= 1) &&
                (settings.isprivatedropzoneenabled || privatefilecount >= 1) &&
                renderCategoryToggle()}
              {/* <div className="search">
            <viedoc-icon name="search" />
          </div>
          <div className="filter-tap">
            <div className="d-flex align-center">
              <p>
                <viedoc-icon name="tune"></viedoc-icon>
              </p>
              <p>{t("COMMON.TEXT_FILTER")}</p>
            </div>
          </div> */}
            </div>
          </header>
          <article>
            {!isEtmfLocked &&
              ((settings?.isshareddropzoneenabled &&
                category === APP_CONST.SHARED_TEXT) ||
                (settings?.isprivatedropzoneenabled &&
                  category === APP_CONST.PRIVATE_TEXT)) && (
                <div
                  {...getRootProps()}
                  style={{
                    border: DragContainer && "2px dashed #7b4dff",
                    height:
                      _.isEmpty(dropZoneDoc) &&
                      !invalidFileUploaded &&
                      !isLoading
                        ? "20rem"
                        : "10rem",
                  }}
                  onDragLeave={() => setDragContainer(false)}
                  onDragEnter={() => setDragContainer(true)}
                  className="upload-area__drop-zone drop-zone"
                  title={t("TMF.TEXT_UPLOAD")}
                >
                  <p className="drop-zone__paragraph">
                    {t("TMF.DROPZONELABEL_DRAGDROPDOCUMENTS")}
                  </p>
                  <input
                    {...getInputProps()}
                    type="file"
                    id="fileInput"
                    className="drop-zone__file-input"
                    accept="image/*"
                  />
                </div>
              )}
          </article>
          {isLoading ? <Loader height={"25%"} /> : renderTable()}
        </section>
      }
    </div>
  );
};

export default TrailMasterDropZone;
